import React from "react";
import { Redirect } from "react-router-dom";
const SignOut = React.lazy(() => import('../views/SignOut/SignOut'));
const SignIn = React.lazy(() => import('../views/SignIn'));
const FieldPage = React.lazy(() => import('../views/fieldPage/fieldPage'));
const Profile = React.lazy(() => import('../views/Profile/Profile'));

const ForgetPassword = React.lazy(() => import('../views/forgetPassword/ForgetPassword'));
const ActiveAccount = React.lazy(() => import('../views/activeAccount/ActiveAccount'));

const AddAttandancePage = React.lazy(() => import('../views/addAttendance/AddAttandancePage'));

const CartPage = React.lazy(() => import('../views/cartPage/cartPage'));
const FieldInfoPage = React.lazy(() => import('../views/fieldInfoPage/fieldInfoPage'));
const PropertyPackagePage = React.lazy(() => import('../views/propertyPackagePage'));
const OrderPage = React.lazy(() => import('../views/orderPage/orderPage'));
const InstallmentPage = React.lazy(() => import('../views/installmentPage'));
const SettingPage = React.lazy(() => import('../views/setting/settings'));
const TicketAdd = React.lazy(() => import('../views/ticketAdd/TicketAdd'));
const TicketList = React.lazy(() => import('../views/tickets/list'));
const AboutMe = React.lazy(() => import('../views/aboutMe/AboutMe'));
const Register = React.lazy(() => import('../views/Register'));
const RegisterCondition = React.lazy(() => import('../views/registerCondition'));
const PackageInfo = React.lazy(() => import('../views/packageInfo/packageInfo'));
const AddDisplacementPage = React.lazy(() => import('../views/addDisplacementPage'));
const CalenderDetails = React.lazy(() => import('../views/calenderDetails'));
const NewDisplacement = React.lazy(() => import('../views/newDisplacement'));
const NewMeeting = React.lazy(() => import('../views/newMeeting'));
const AttendanceListPage = React.lazy(() => import('../views/attendanceListPage'));
const Help = React.lazy(() => import('../views/help'));
export const RouteList = [
    {
        exact: true,
        path: "/",
        component: <Redirect to="/app/fieldList" />,
        auth: false,
    },
    {
        exact: true,
        path: "/auth/signin",
        component: <SignIn />,
        auth: false,
    },
    {
        exact: true,
        path: "/auth/register",
        component: <Register />,
        auth: false,
    },
    {
        exact: true,
        path: "/auth/registerCondition",
        component: <RegisterCondition />,
        auth: false,
    },
    {
        exact: true,
        path: "/auth/forgetPassword",
        component: <ForgetPassword />,
        auth: false,
    },
    {
        exact: true,
        path: "/auth/activeAccount",
        component: <ActiveAccount />,
        auth: false,
    },
    {
        exact: true,
        path: "/app/signout",
        component: <SignOut />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/fieldList",
        component: <FieldPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/profile",
        component: <Profile />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/field/info/:fieldId",
        component: <FieldInfoPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/package/info/:packageId",
        component: <PackageInfo />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/propertyPackages",
        component: <PropertyPackagePage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/cartPage",
        component: <CartPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/addAttendance",
        component: <AddAttandancePage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/addAttendance",
        component: <AddAttandancePage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/orders",
        component: <OrderPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/addDisplacementPage/:orderId",
        component: <AddDisplacementPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/installments",
        component: <InstallmentPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/ticketAdd",
        component: <TicketAdd />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/tickets",
        component: <TicketList />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/setting",
        component: <SettingPage />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/aboutMe",
        component: <AboutMe />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/calenderDetails/:orderId",
        component: <CalenderDetails />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/help",
        component: <Help />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/newDisplacement/:orderId",
        component: <NewDisplacement />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/newMeeting/:orderId",
        component: <NewMeeting />,
        auth: true,
    },
    {
        exact: true,
        path: "/app/attendanceList",
        component: <AttendanceListPage />,
        auth: true,
    },
]
